var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('div',{staticClass:"relative w-full"},[_c('div',{ref:"swiperRefThumb",staticClass:"thumb-swiper-container swiper-container",attrs:{"id":"thumb-swiper"}},[_c('div',{staticClass:"flex",class:{
        'swiper-wrapper': _vm.isSliderLoaded,
        hidden: !_vm.isSliderLoaded,
      }},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"swiper-slide thumb-swiper-slide"},[_vm._t("default",null,{"item":item})],2)}),0)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }